module.exports = __webpack_public_path__ + "img/3.e40102ff.jpg";